import TituloSeccionH2 from '@/components/elements/TituloSeccionH2';
import { LoginDatos } from '@/objects/User';
import { Card } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import CheckBoxCustom from '@/components/elements/Checkbox';
import Boton from '@/components/elements/Boton';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import { useServices } from '@/context/ServicesProvider';
import { mostrarAlerta } from '@/context/UtilsContext';
import { refrescarDatosUsuarioLogin } from '@/util/LocalStorageLoaded';
import { subtitulo } from '@/constants/Dimens';
import { AxiosResponse } from 'axios';

interface Props {
    datosUsuario: LoginDatos | null;
}

const DatosMostrarMapa: React.FC<Props> = ({ datosUsuario }) => {

    const { usersQueries } = useServices();

    const [mostrar_mapa, setMostrarMapa] = React.useState<boolean>(false);

    const { t } = useTranslation();

    //Obtener el valor de mostrar mapa al cargar el componente
    useEffect(() => {
        if (datosUsuario == null) return;
        usersQueries?.getMostrarMapa(datosUsuario?.id_user!).then((response: AxiosResponse<number>) => {
            setMostrarMapa(response.data === 1);
        });
    }, [datosUsuario]);


    function guardarDatos() {
        usersQueries?.guardarMostrarMapa(datosUsuario?.id_user!, mostrar_mapa ? 1 : 0).then((response) => {
            mostrarAlerta({
                title: t('common:opciones.informacion'),
                content: t("menu:secciones.ajustes_perfil.datos_actualizados_correctamente"),
                showCancelButton: false,
            });
            usersQueries?.obtenerDatosUsuario().then((response) => {
                if (response.data) {
                    refrescarDatosUsuarioLogin(response.data);
                }
            }
            );
        });
    }

    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: "100%" }}>
            <TituloSeccionH2 fontSize={subtitulo} texto={t("menu:secciones.ajustes_perfil.avisos_email_alertas_datos")} />
            <div style={{ display: 'flex', flexDirection: 'column', width: "100%", alignItems: 'center', }}>
                <Card style={{
                    display: 'flex', flexDirection: 'column', justifyContent: 'center',
                    alignItems: 'center', gap: '5px', padding: "20px", width: "100%"
                }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: "flex-start", marginBottom: "20px" }}>
                        <CheckBoxCustom idCheck='avisos_alertas_libros' label={t("menu:secciones.ajustes_perfil.mostrar_mapa")} isChecked={mostrar_mapa} onCheckChange={setMostrarMapa} />
                    </div>
                    <Boton fullWidth startIcon={<BrowserUpdatedIcon />} texto={t("menu:secciones.ajustes_perfil.actualizar_datos")} onClick={() => guardarDatos()} />
                </Card>
            </div>
        </section>
    );
}

export default DatosMostrarMapa;
